/** Grid page-size preference, persisted per table. `localStorage` throws outright when site data is
 *  blocked, and these run inside AG Grid callbacks where a throw kills grid init or the event loop. */

export function readPageSize(key: string, fallback: number, options: readonly number[]): number {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(key);
  } catch (error) {
    console.warn(`[${key}] page-size preference unreadable; using ${fallback}`, error);
    return fallback;
  }

  if (raw === null) return fallback;

  // Number() over parseInt: parseInt('10abc') is 10, which would silently accept a corrupt value.
  const parsed = Number(raw);
  if (!Number.isInteger(parsed) || !options.includes(parsed)) {
    console.warn(`[${key}] ignoring unusable stored page size ${JSON.stringify(raw)}; using ${fallback}`, null);
    return fallback;
  }

  return parsed;
}

export function writePageSize(key: string, size: number): void {
  try {
    localStorage.setItem(key, String(size));
  } catch (error) {
    console.warn(`[${key}] could not persist page size ${size}; it will not survive a reload`, error);
  }
}
